/**
 * How a plot is named wherever one is chosen: "PLT-000001 · P1 · north block - Lakshmi Bai" - the
 * code, the farmer's plot number, the family's name for it, then whose it is. The same as
 * api.fn_plot_options (migration 640000), so a plot reads alike in every dropdown and filter
 * (found in the 2026-09-28 UI pass: four pages named plots four ways).
 */
export function plotLabel(plot: { plot_code?: string | null; plot_no?: string | null; plot_name?: string | null; farmer_name?: string | null }): string {
  const head = [plot.plot_code, plot.plot_no, plot.plot_name?.trim()].filter(Boolean).join(' · ');
  return plot.farmer_name ? `${head} - ${plot.farmer_name}` : head;
}
